import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

function GridIcon(props: IconProps) {
  return (

    <SvgIcon viewBox="0 0 24 24"  color="inherit" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 3H3V10H10V3Z" stroke="currentColor" strokeWidth="2" stroke-linecap="round" fill="none" stroke-linejoin="round"/>
      <path d="M21 3H14V10H21V3Z" stroke="currentColor" strokeWidth="2" stroke-linecap="round" fill="none" stroke-linejoin="round"/>
      <path d="M21 14H14V21H21V14Z" stroke="currentColor" strokeWidth="2" stroke-linecap="round" fill="none"  stroke-linejoin="round"/>
      <path d="M10 14H3V21H10V14Z" stroke="currentColor" strokeWidth="2" stroke-linecap="round" fill="none"  stroke-linejoin="round"/>
    </SvgIcon>
  );
}

export default GridIcon;
